export const initStatePaymentsBudgets = (
    Object.assign({
        data             : [],
        confirmed        : '',
        start_date       : '',
        end_date         : '',
        payments_methods : new Array(5).fill(false),
        filter_payments  : [],
        with_permission  : true
    })
);